import React from 'react'

import {
  NotificationBase,
  NotificationBaseProps,
} from './NotificationBase.component'
import { conditionalClass, cssClass } from '@/shared/utils'
import { ButtonComponent, ButtonProps } from '../buttons'
import Link from 'next/link'
import { BrowserContext } from '../../../context'

export interface NotificationSystemProps
  extends Partial<NotificationBaseProps> {
  buttons?: ButtonProps[]
  texts?: (string | JSX.Element)[]
  isInsider?: boolean
}

export const NotificationSystem = ({
  images,
  texts,
  buttons,
  isInsider,
}: NotificationSystemProps) => {
  const { isMobile } = React.useContext(BrowserContext)

  return (
    <NotificationBase images={images} alignItems="items-start">
      <div>
        {texts?.map((text, index) => (
          <p
            key={index + '_notificationSystem'}
            className={cssClass([
              'm-0 text-14 text-16--tablet text-primary font-normal',
              conditionalClass(index >= 1, 'mt-20 mt-24--tablet'),
            ])}
          >
            {text}
          </p>
        ))}

        {isInsider && (
          <p className="text-12 text-14--tablet text-secondary font-normal">
            Become an{' '}
            <Link className="text-info" href="/checkout">
              Insider
            </Link>{' '}
            and unlock customized and detailed analytics for your TikTok,
            Instagram and YouTube accounts delivered via email monthly.{' '}
            <Link
              className="text-info"
              href="https://drive.google.com/file/d/1IfYhBAY4UCK21oRVCTRSMTJYhr6ACKsu/view"
              target="_blank"
            >
              View Mr Beast&apos;s Sample Report
            </Link>
            .
          </p>
        )}
      </div>
      {buttons?.length && (
        <div
          className={cssClass([
            'gap-12 mt-16',
            conditionalClass(!isMobile, 'flex items-center'),
          ])}
        >
          {buttons?.map((button, index) => (
            <ButtonComponent
              {...button}
              key={index + button?.label}
              className={conditionalClass(
                isMobile && buttons.length > 1,
                'mt-16'
              )}
            />
          ))}
        </div>
      )}
    </NotificationBase>
  )
}
